import { render, staticRenderFns } from "./FormDocumentMultipleUploadsInput.vue?vue&type=template&id=8ca8e10a"
import script from "./FormDocumentMultipleUploadsInput.vue?vue&type=script&lang=js"
export * from "./FormDocumentMultipleUploadsInput.vue?vue&type=script&lang=js"
import style0 from "./FormDocumentMultipleUploadsInput.vue?vue&type=style&index=0&id=8ca8e10a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports